// Lightweight CSV serialisation for client-side chart exports.
//
// The backend's full /export.csv path streams via stdlib csv (RFC 4180);
// this util is just for the 3-column aggregate roll-up the chart toolbar
// downloads. UTF-8 BOM keeps Excel from mis-detecting non-ASCII country
// names (e.g. "Türkiye").

const BOM = "﻿";

function escapeCell(value: string | number): string {
  const raw = String(value);
  const s = /^[ \t\r\n]*[=+\-@]/.test(raw) ? `'${raw}` : raw;
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function rowsToCsv(
  rows: ReadonlyArray<Record<string, string | number>>,
  columns: ReadonlyArray<{ key: string; header: string }>,
): string {
  const headerLine = columns.map((c) => escapeCell(c.header)).join(",");
  const lines = rows.map((row) =>
    columns.map((c) => escapeCell(row[c.key] ?? "")).join(","),
  );
  return BOM + [headerLine, ...lines].join("\r\n") + "\r\n";
}

export function downloadBlob(content: string, mime: string, filename: string): void {
  const blob = new Blob([content], { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  try {
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
  } finally {
    a.remove();
    // Defer revocation so Safari has time to start the download.
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
